import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" {...props}><title>警示</title><path d="M8 1a7 7 0 110 14A7 7 0 018 1zm0 1.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 8A.75.75 0 118 12a.75.75 0 010-1.5zM8 4a.8.8 0 01.78.82l-.02 3.85c0 .46-.35.83-.76.83-.41 0-.76-.37-.76-.83l-.02-3.85A.8.8 0 018 4z" fill="#FF3826" fillRule="nonzero" /></svg>);